import { FormattedMessage } from 'react-intl';

import { Typography } from '@/components/ui/typography';

import type { PostingResultScenario } from '../types';

interface ResultHeaderProps {
  scenario: PostingResultScenario;
}

const TITLE_COLOR: Record<PostingResultScenario, string> = {
  'all-success': 'text-fx-green',
  partial: 'text-fx-amber',
  'all-failed': 'text-fx-rose',
};

export function ResultHeader({ scenario }: ResultHeaderProps) {
  return (
    <div className="flex w-full flex-col gap-3">
      <Typography variant="h4" className={TITLE_COLOR[scenario]}>
        {scenario === 'all-success' && (
          <FormattedMessage
            defaultMessage="Your job has been posted successfully 🎉"
            description="Result page title when all job postings succeeded"
          />
        )}
        {scenario === 'partial' && (
          <FormattedMessage
            defaultMessage="Your job postings are complete with some issues"
            description="Result page title when some job postings failed"
          />
        )}
        {scenario === 'all-failed' && (
          <FormattedMessage
            defaultMessage="We couldn't post your jobs"
            description="Result page title when all job postings failed"
          />
        )}
      </Typography>

      <Typography variant="body1" className="text-fx-neutral-900">
        {scenario === 'all-success' && (
          <FormattedMessage
            defaultMessage="All selected openings have been successfully posted across all channels. Applicants will begin flowing in soon."
            description="Result page description when all job postings succeeded"
          />
        )}
        {scenario === 'partial' && (
          <FormattedMessage
            defaultMessage="Some openings were successfully posted, while others encountered channel-level errors. Only successful postings were billed."
            description="Result page description when some job postings failed"
          />
        )}
        {scenario === 'all-failed' && (
          <FormattedMessage
            defaultMessage="All openings failed to post across the selected channels. No charges have been applied."
            description="Result page description when all job postings failed"
          />
        )}
      </Typography>
    </div>
  );
}
